module.exports = __webpack_public_path__ + "static/media/pinktadaLogo.0be331cc.png";